// extracted by mini-css-extract-plugin
export var bounce = "_oj-1";
export var generatingText = "_oj-6";
export var lightning = "_oj-4";
export var popup = "_oj-5";
export var progressBar = "_oj-7";
export var progressFill = "_oj-8";
export var progressShimmer = "_oj-9";
export var progressText = "_oj-a";
export var shimmer = "_oj-3";
export var uploadIcon = "_oj-0";
export var uploadingText = "_oj-2";